import { z } from "zod";

const envSchema = z.object({
  VITE_PUBLIC_API_BASE_URL: z.url(),
  VITE_CLERK_PUBLISHABLE_KEY: z.string().min(1),
});

const parsedEnv = envSchema.safeParse({
  VITE_PUBLIC_API_BASE_URL: import.meta.env.VITE_PUBLIC_API_BASE_URL,
  VITE_CLERK_PUBLISHABLE_KEY: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY,
});

if (!parsedEnv.success) {
  throw new Error(`Invalid environment variables: ${JSON.stringify(z.treeifyError(parsedEnv.error), null, 2)}`);
}

export default Object.freeze({
  apiBaseUrl: parsedEnv.data.VITE_PUBLIC_API_BASE_URL,
  clerkPublishableKey: parsedEnv.data.VITE_CLERK_PUBLISHABLE_KEY,
});
